// extracted by mini-css-extract-plugin
module.exports = {"system-tag":"_1_a97Qtl5ZYptznDacf916","system-tag-comma-space":"_3zy86OPq1u3MRjPZYgdeHL"};